<template>
  <div class="big-box">
    <div class="list-item" v-for="(item,index) in navList" :key="index">
      <div class="first-item flexSpace first-item-name displayIB" @click="goNav(item,index)">
        {{item.name}}
      </div>
      <div class="first-item-hr" v-if="index+1<navList.length"></div>
    </div>
    <!--    <vue-scroll class="page-scroll">-->
    <!--    <div class="top-close-box" @click="closeNav">-->
    <!--      <img src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/phone/cha.png" class="top-close-icon" />-->
    <!--    </div>-->
    <!--     <div class=""></div>     <div class="" ></div> <div class="first-item-more flexCenter" v-if="item.children" @click="showSecondList(index)">-->
    <!--            <img class="more-icon-right" v-show="!item.showStatus" src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/phone/rowyou.png" />-->
    <!--            <img class="more-icon-bottom" v-show="item.showStatus" src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/phone/rowxia.png" />-->
    <!--          </div>-->
    <!--          <div class="first-item-more" v-else></div>-->
    <!--        <div class="second-item flexStart" v-if="item.children&&item.showStatus" v-for="(item1,index1) in item.children" :key="index1+99" @click="goNav(item1,index1)">-->
    <!--          <div class="second-item-name">{{item1.name}}</div>-->
    <!--        </div>-->
    <!--    </vue-scroll>-->
  </div>
</template>
<script>
import {$get, } from '../../others/ajax';
import config from '@/others/interface';

export default {
  name: 'TopMainNav',
  data () {
    return {
      toplist: [],
      navList: [
        {
          name: '首页',
          hrefs: '/',
          showStatus: false,
        },
        // {
        //   name: '减肥案例',
        //   hrefs: '/caseVideo/0-1-anlishipin.html',
        //   showStatus: false,
        //   children: [
        //     {
        //       name: '案例视频',
        //       hrefs: '/caseVideo/0-1-anlishipin.html',
        //     },
        //     {
        //       name: '案例分享',
        //       hrefs: '/caseSharing/1-1-anlifenxiang.html',
        //     },
        //   ],
        // },
        {
          name: '关于产品',
          hrefs: '/aboutProducts/guanyuchanpin.html',
          showStatus: false,
        },
        {
          name: '减肥视频',
          hrefs: '',
          showStatus: false,
          children: [],
        },
        {
          name: '减肥知识',
          hrefs: '',
          showStatus: false,
          children: [],
        },
        {
          name: '品牌资讯',
          hrefs: '/brandInfo/A5-0-1-pinpaizixun.html',
          showStatus: false,
        },
        {
          name: '防伪查询',
          hrefs: '/search/fangweichaxun.html',
          showStatus: false,
        },
        {
          name: '脂玫乐APP',
          hrefs: '/zmlapp/ZmlAPP.html',
          showStatus: false,
        },
        {
          name: '使用说明',
          hrefs: '/use/Directions.html',
        },
        {
          name: '联系我们',
          hrefs: '/about/lianxiwomen.html',
          showStatus: false,
        },
      ],
      helpcode:'',
      helpcode2:'',
    };
  },
  methods: {
    getTopList () {
      $get(config.zmlgw + '/web/getEndClass', {}).then((res) => {
        if (res.code == 200) {
          this.toplist = res.returnData;
          this.helpcode = pinyinUtil.getPinyin(res.returnData[1].data[0].text, '', false, false);
          this.helpcode2 = pinyinUtil.getPinyin(res.returnData[0].data[0].text, '', false, false)
          // console.log(res.returnData);
          // res.returnData[0].data.map((item, index) => {
          //   let obj = {
          //     name: item.text,
          //     id: item.id,
          //     parent: '减肥资讯',
          //   };
          //   this.navList[4].children.push(obj);
          // });
          // res.returnData[1].data.map((item, index) => {
          //   let obj = {
          //     name: item.text,
          //     id: item.id,
          //     parent: '瘦身百科',
          //   };
          //   this.navList[3].children.push(obj);
          // });
        }
      });
    },
    goNav (item, index) {
      console.log(this.toplist)
      // console.log(pinyinUtil.getPinyin(this.toplist[1].data[0].text, '', false, false))
      // console.log(pinyinUtil.getPinyin(this.toplist[0].data[0].text, '', false, false))
      // let helpcode = pinyinUtil.getPinyin(this.toplist[1].data[0].text, '', false, false);
      // let helpcode2 = pinyinUtil.getPinyin(this.toplist[0].data[0].text, '', false, false);
      if (index == 2) {
        this.$router.push({path: '/encyclopeDias/' + this.toplist[1].data[0].id + '-0-1-' + this.helpcode + '.html', });
        this.closeNav();
      }
      if (index == 3) {
        this.$router.push({path: '/InformationList/' + this.toplist[0].data[0].id + '-0-1-' + this.helpcode2 + '.html', });
        this.closeNav();
      }
      if (item.hrefs) {
        this.closeNav();
        this.$router.push({path: item.hrefs, });
      }
    }, // 去一二级导航
    closeNav () {
      this.$store.commit('changeMainNavShowStatus');
    }, // 关闭弹框
  },
  created () {
    this.getTopList();
  },
};
</script>

<style lang="less" scoped>
  @import url("./TopMainNav.less");
</style>



// WEBPACK FOOTER //
// TopMainNav.vue